import React from "react";

const Billing = () => {
	return <h4 class="fw-bold py-3 mb-4">Billing</h4>;
};

export default Billing;
